import { render, staticRenderFns } from "./RadioaktifViewNew.vue?vue&type=template&id=953fc8e0&scoped=true&lang=pug&"
import script from "./RadioaktifViewNew.vue?vue&type=script&lang=js&"
export * from "./RadioaktifViewNew.vue?vue&type=script&lang=js&"
import style0 from "./RadioaktifViewNew.vue?vue&type=style&index=0&id=953fc8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953fc8e0",
  null
  
)

export default component.exports